
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { FolhaHoras } from '@app/model/horas';
import { Filtro, Pesquisa } from '@app/model/util';
import { CustosHora } from '@app/model';


@Injectable({
  providedIn: 'root'
})
export class HorasService {

  options: {
    headers?: HttpHeaders | { [header: string]: string | string[] },
    observe?: 'body' | 'events' | 'response',
    params?: HttpParams | { [param: string]: string | string[] },
    reportProgress?: boolean,
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    withCredentials?: boolean,
  }

  // Apontamos ao 4200(front) porque temos a proxy aplicada
  url = '/apiat';

  urlLista = "/horas/lista";
  urlListaCustos = "/horas/lista/custos";
  urlSearch = "/horas/search";
  urlFixCustos = "/horas/fixCustos";
  urlCount = "/horas/count";
  urlObter = "/horas/";
  urlInserirAlterar = "/horas";
  urlRemover = "/horas/";
  urlRemoverPeriodo = "/horas/delPeriodo";
  urlExport = "/exportFolhaHoras";
  urlExportHorasCSV = "/exportHorasCSV";
  urlExportFolhaHorasCSV = "/exportFolhaHorasCSV";
  urlExportTarefasCSV = "/exportTarefasCSV";


  // injetando o HttpClient
  constructor(
    private http: HttpClient
  ) {
  }

  // Headers
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }


  //  /** GET folhasHoras from the server */

  list(): Observable<FolhaHoras[]> {
    console.log('folhasHoras.list');
    return this.http.post<FolhaHoras[]>(this.url + this.urlLista, '', this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  listCustos(): Observable<CustosHora[]> {
    console.log('folhasHoras.listCustos');
    return this.http.get<CustosHora[]>(this.url + this.urlListaCustos, this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  search(pesquisa: Pesquisa): Observable<FolhaHoras[]> {
    console.log('folhasHoras.search', pesquisa);
    console.log('folhasHoras.search.json', JSON.stringify(pesquisa));
    return this.http.post<FolhaHoras[]>(this.url + this.urlSearch, JSON.stringify(pesquisa), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  fixCustos(pesquisa: Pesquisa): Observable<boolean> {
    console.log('folhasHoras.fixCustos', pesquisa);
    console.log('folhasHoras.fixCustos.json', JSON.stringify(pesquisa));
    return this.http.post<boolean>(this.url + this.urlFixCustos, JSON.stringify(pesquisa), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }

  count(filtro: Filtro): Observable<Number> {
    console.log('folhasHoras.count', filtro);
    console.log('folhasHoras.count.json', JSON.stringify(filtro));
    return this.http.post<Number>(this.url + this.urlCount, JSON.stringify(filtro), this.httpOptions)
      .pipe(
        retry(2), // numero de x que executa chamada se obtiver erro
        catchError(this.handleError)
      )
  }


  // Obter folhasHoras pelo id
  get(id: number): Observable<FolhaHoras> {
    return this.http.get<FolhaHoras>(this.url + this.urlObter + id)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  //////// Save methods //////////

  /** POST: add/edit a client to the database */
  save(msgFolhaHoras: FolhaHoras): Observable<void> {
    console.log('save POST ' + this.url + this.urlInserirAlterar);
    console.log(msgFolhaHoras);
    return this.http.post<void>(this.url + this.urlInserirAlterar, JSON.stringify(msgFolhaHoras), this.httpOptions)
      .pipe(
        retry(2),
        catchError(this.handleError)
      )
  }

  /** DELETE: delete the client from the server */
  delete(msgFolhaHoras: FolhaHoras) {
    return this.http.delete<FolhaHoras>(this.url + this.urlRemover + msgFolhaHoras.idRegisto, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  deletePeriodo(periodo: string) {
    return this.http.post<FolhaHoras>(this.url + this.urlRemoverPeriodo, periodo, this.httpOptions)
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  export(periodo: string, utilizador: string): Observable<any> {
    const params = new HttpParams()
      .set('periodo', periodo)
      .set('utilizador', utilizador);
    console.log('body', params);


    return this.http.post(this.url + this.urlExport, params, {
      // headers: httpFormHeaders,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      observe: 'response',
      // reportProgress: false,
      responseType: 'blob',
      // withCredentials: false
    });
  }

  exportFolhaHorasCSV(periodo: string, utilizador: string): Observable<any> {
    const params = new HttpParams()
      .set('periodo', periodo)
      .set('utilizador', utilizador);
    console.log('body', params);


    return this.http.post(this.url + this.urlExportFolhaHorasCSV, params, {
      // headers: httpFormHeaders,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      observe: 'response',
      // reportProgress: false,
      responseType: 'blob',
      // withCredentials: false
    });
  }

exportHorasCSV(periodo: string, utilizador: string): Observable<any> {
    const params = new HttpParams()
      .set('periodo', periodo)
      .set('utilizador', utilizador);
    console.log('body', params);


    return this.http.post(this.url + this.urlExportHorasCSV, params, {
      // headers: httpFormHeaders,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      observe: 'response',
      // reportProgress: false,
      responseType: 'blob',
      // withCredentials: false
    });
  }

    exportTarefasCSV(periodo: string, utilizador: string): Observable<any> {
    const params = new HttpParams()
      .set('periodo', periodo)
      .set('utilizador', utilizador);
    console.log('body', params);


    return this.http.post(this.url + this.urlExportTarefasCSV, params, {
      // headers: httpFormHeaders,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      observe: 'response',
      // reportProgress: false,
      responseType: 'blob',
      // withCredentials: false
    });
  }


  // Manipulação de erros
  //O angular recomenda que métodos de manipulação de erros devem ser nos serviços e não nos componentes.
  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    //console.log(error);
    //console.log(error.error);
    //console.log(error.error.typeof());
    if (typeof(error.error) == "string") {
      errorMessage = error.error;
    } else if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `mensagem: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  };

}
